<template>
  <div>
    <!-- <button v-on:click="visibility = !visibility">Toggle</button> -->
    <transition name="fade">
      <div v-if="visibility" id="danger-fade-alert">
        <div class="alert alert-danger" role="alert">
          <p>{{msg}}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "FadeAlertDanger",
  props: {
    msg: String
  },
  data: function() {
    return {
      visibility: false
    };
  },
  methods: {
    hide() {
      this.visibility = false;
    },
    show() {
      this.visibility = true;

      const sleep = milliseconds => {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
      };

      const doSomething = async () => {
        await sleep(4000);
        this.visibility = false;
      };

      doSomething();
    }
  }
};
</script>

<style scoped>

#danger-fade-alert {
  position: fixed;
  top: 10px;
  left: 0px;
  width: 100%;
  z-index: 9999;
  border-radius: 0px;
  text-align: center;
}

.fade-enter-active {
  transition: opacity 2s;
  position: fixed;
  top: 10px;
  z-index: 1;
}

.fade-leave-active {
  transition: opacity 2s;
  position: fixed;
  top: 10px;
  z-index: 1;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.5;
}
</style>